module.exports = require("/home/runner/work/erdem.pl/erdem.pl/src/styles-provider-props")